import React from 'react';
import BackButton from '../BackButton';
import { useTheme } from '../../contexts/ThemeContext';
import { MARKETING_BASE } from '../../utils/marketingTabs';

/**
 * Standard back + title row for Marketing sub-pages when not embedded in the tab shell.
 */
const MarketingPageHeader = ({ title, backTo = MARKETING_BASE }) => {
  const { darkMode } = useTheme();

  return (
    <div className="flex justify-between items-center mb-8">
      <BackButton onClick={() => { window.location.href = backTo; }} />
      <h1 className={`text-3xl font-bold flex-1 text-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
        {title}
      </h1>
      <div className="w-10" />
    </div>
  );
};

export default MarketingPageHeader;
